// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export type TraduccionCmpGdprSinLogoP1AppParams = Record<"brand", string>;

export class TraduccionCmpGdprSinLogoP1App extends TraduccionLiteral<TraduccionCmpGdprSinLogoP1AppParams> {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.p_1_app";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoP1App {
        this.VALUES ??= this.completar({
            "valor": {
                "en": "The content of {{brand}} has been prepared by professionals to ensure that the information provided is of high quality. You can access this app using the following options:",
                "es": "El contenido de {{brand}} ha sido elaborado por profesionales para garantizar que la información que se ofrece es de calidad. Puedes acceder a esta app mediante las siguientes opciones:"
            },
            "defecto": "The content of {{brand}} has been prepared by professionals to ensure that the information provided is of high quality. You can access this app using the following options:"
        }, idiomas);

        return super.build(lang, this.VALUES, ["brand"]);
    }

    /* INSTANCE */
}
